export default (props, inject) => {
  const productSku = function (product = {}) {
    const characteristicGroupId = product?.characteristicGroupId || 0;

    // Возвращаем SKU товара
    const skuCharacteristicGroupIds = [13, 12, 26, 9, 8, 7, 10];
    if (skuCharacteristicGroupIds.includes(characteristicGroupId)) {
      return product?.sku;
    }

    return product?.code;
  };

  inject('productSku', productSku);
};
